/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpRightIcon20Solid = forwardRef('ArrowShapeAUpRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.75 3A2.25 2.25 0 0 1 17 5.25v10.176c0 1.203-1.454 1.805-2.304.955l-2.117-2.117-3.352 3.351a2 2 0 0 1-2.828 0l-4.013-4.014a2 2 0 0 1 0-2.828l3.35-3.351L3.62 5.305C2.77 4.455 3.371 3 4.574 3H14.75Z" })));
});
